"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./RequestDemoButton.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RequestDemoButton = function RequestDemoButton(props) {
  return /*#__PURE__*/_react.default.createElement("a", {
    className: "btn-demo",
    href: props.url,
    target: "_blank"
  }, "REQUEST A DEMO");
};

var _default = RequestDemoButton;
exports.default = _default;